import React, { useState, useEffect, useCallback } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiStar, FiChevronLeft, FiChevronRight } from 'react-icons/fi';

const testimonials = [
    {
        name: "Prathibha Vinod",
        title: "4 BHK Villa – Ananthapur (Complete)",
        text: "Transforming our 4 BHK villa was a massive undertaking, but Bliv Design Studio handled it with such elegance and precision. The final handover was seamless, and the quality is exceptional."
    },
    {
        name: "Teja Ranjith",
        title: "3 BHK – Vizag, Overall Flat Interior",
        text: "We are thrilled with the overall flat interior for our 3 BHK in Vizag. From the modular kitchen to the bedrooms, every space feels premium and thoughtfully designed."
    },
    {
        name: "Madhuri Ratna",
        title: "2 BHK – Hyderabad, Mallampet",
        text: "Our 2 BHK in Mallampet feels so much more spacious and modern now. The smart storage solutions and beautiful false ceiling designs have truly elevated our home."
    },
    {
        name: "Venugopal (Aparna Villas)",
        title: "Kukatpally – Hyderabad",
        text: "Designing a villa in Aparna was a dream, and Bliv made it a reality. Their professionalism and artistic vision for our home in Kukatpally were outstanding."
    },
    {
        name: "Palle Kishore",
        title: "Bungalow  – Ananthapur",
        text: "The interior work for our Bungalow  in Ananthapur is top-notch. The attention to detail in the woodwork and the choice of color palettes is exactly what we wanted."
    },
    {
        name: "Srinivas",
        title: "Blossoms Villa – LB Nagar, Hyd",
        text: "Extremely happy with the Blossom Villa project in LB Nagar. The team was dedicated and delivered a world-class interior that our family absolutely loves."
    },
    {
        name: "Dr. Naveen",
        title: "Vue Residency – Puppalguda, 3 BHK",
        text: "Our 3 BHK at Vue Residency is now a masterpiece of modern design. Bliv Design Studio's expertise and timely delivery were highly impressive."
    }
];

export default function Testimonials() {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isAutoPlaying, setIsAutoPlaying] = useState(true);

    const nextSlide = useCallback(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
    }, []);

    const prevSlide = () => {
        setCurrentIndex((prevIndex) => (prevIndex - 1 + testimonials.length) % testimonials.length);
    };

    useEffect(() => {
        let interval;
        if (isAutoPlaying) {
            interval = setInterval(nextSlide, 5000);
        }
        return () => clearInterval(interval);
    }, [isAutoPlaying, nextSlide]);

    return (
        <section className="section-pad bg-[#F8F9FA]" id="reviews">
            <div className="max-w-7xl mx-auto px-4">
                <div className="text-center mb-12">
                    <p className="text-[#2E63E8] font-semibold uppercase tracking-widest text-sm mb-2">Testimonials</p>
                    <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">Our Customer Reviews</h2>
                    <div className="w-20 h-1 bg-[#2E63E8] mx-auto rounded-full"></div>
                </div>

                <div className="relative overflow-hidden group">
                    <div
                        className="flex transition-transform duration-500 ease-in-out"
                        style={{ transform: `translateX(-${currentIndex * 100}%)` }}
                        onMouseEnter={() => setIsAutoPlaying(false)}
                        onMouseLeave={() => setIsAutoPlaying(true)}
                    >
                        {testimonials.map((review, index) => (
                            <div key={index} className="w-full flex-shrink-0 px-4">
                                <div className="bg-white rounded-3xl p-8 md:p-12 shadow-xl border border-gray-100 flex flex-col items-center text-center max-w-3xl mx-auto">
                                    <div className="flex justify-center gap-1 mb-6">
                                        {[...Array(5)].map((_, i) => (
                                            <FiStar key={i} className="fill-[#2E63E8] text-[#2E63E8]" size={22} />
                                        ))}
                                    </div>
                                    <h3 className="text-2xl font-bold text-gray-900 mb-4">{review.title}</h3>
                                    <p className="text-gray-600 text-lg italic mb-8 leading-relaxed max-w-2xl mx-auto">
                                        "{review.text}"
                                    </p>
                                    <div>
                                        <p className="font-bold text-[#2E63E8] text-lg">{review.name}</p>
                                        <p className="text-gray-400 text-sm uppercase tracking-widest mt-1">Verified Client</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Navigation Buttons */}
                    <button
                        onClick={prevSlide}
                        className="absolute left-0 top-1/2 -translate-y-1/2 bg-white/80 backdrop-blur-sm p-3 rounded-full shadow-lg text-gray-800 hover:bg-[#2E63E8] hover:text-white transition-all opacity-0 group-hover:opacity-100 hidden md:block"
                    >
                        <FiChevronLeft size={24} />
                    </button>
                    <button
                        onClick={nextSlide}
                        className="absolute right-0 top-1/2 -translate-y-1/2 bg-white/80 backdrop-blur-sm p-3 rounded-full shadow-lg text-gray-800 hover:bg-[#2E63E8] hover:text-white transition-all opacity-0 group-hover:opacity-100 hidden md:block"
                    >
                        <FiChevronRight size={24} />
                    </button>
                </div>

                {/* Dots / Pagination */}
                <div className="flex justify-center gap-3 mt-12">
                    {testimonials.map((_, index) => (
                        <button
                            key={index}
                            onClick={() => setCurrentIndex(index)}
                            className={`h-2.5 transition-all duration-300 rounded-full ${currentIndex === index ? 'w-8 bg-[#2E63E8]' : 'w-2.5 bg-gray-300 hover:bg-gray-400'
                                }`}
                            aria-label={`Go to slide ${index + 1}`}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
}
